import { MenuRow } from '@repo/studio-components-menu-row'
import * as React from 'react'
import { StudioLayoutLink } from '@repo/studio-config/studio-config-router'
import type { ClusterDefinition, NavigationClusterId } from './navigation-cluster-data'

/**
 * A menu row opens a sub-list in place rather than navigating, so it claims the menu
 * promise (`role`/`aria-haspopup`/`aria-expanded`). A link row goes to its route and
 * makes no such promise and draws no chevron.
 */
export function StackedClusterRow({
  definition,
  activeCluster,
  onOpen,
  onNavigate,
}: {
  definition: ClusterDefinition
  activeCluster: NavigationClusterId | null
  onOpen: (cluster: NavigationClusterId) => void
  onNavigate: () => void
}) {
  const { cluster, label, icon } = definition

  if (definition.behaviour === 'link') {
    return (
      <MenuRow asChild variant="slim">
        <MenuRow.Link asChild>
          <StudioLayoutLink to={definition.route} onClick={onNavigate}>
            <MenuRow.Icon className="text-gray-200 mr-4">{icon}</MenuRow.Icon>
            <MenuRow.Label>{label}</MenuRow.Label>
          </StudioLayoutLink>
        </MenuRow.Link>
      </MenuRow>
    )
  }

  return (
    <MenuRow
      variant="slim"
      className="cursor-pointer"
      onClick={() => onOpen(cluster)}
      tabIndex={0}
      role="button"
      aria-haspopup="true"
      aria-expanded={activeCluster === cluster}
    >
      <MenuRow.Icon className="text-gray-200 mr-4">{icon}</MenuRow.Icon>
      <MenuRow.Label>{label}</MenuRow.Label>
      <MenuRow.Indicator />
    </MenuRow>
  )
}
